// NotFound.js
import React from "react";
import notFoundImg from '../assets/images/error-404.png';

const NotFound = () => {
  return (
    <div className="notfound-container">
      <img
        src={notFoundImg}
        alt="Not Found"
        className="notfound-img img-fluid"
      />
      <h1 className="notfound-title">404 - Page Not Found</h1>
      <p className="notfound-text">
        The page you are looking for doesn't exist.
      </p>
    </div>
  );
};

export default NotFound;
